import './styles.css';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { WalletBalance } from '../Wallet';
import { useState, useRef, useEffect } from 'react';
import { ChevronDown, LogOut, Menu, UserRound } from 'lucide-react';

function Landing({ userProfile, isAdmin }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const handleNavClick = () => {
        setMobileMenuOpen(false);
    };

    const handleEditProfile = () => {
        setDropdownOpen(false);
        setMobileMenuOpen(false);
        navigate('/Profile');
    };

    const handleLogout = () => {
        setDropdownOpen(false);
        setMobileMenuOpen(false);
        logout();
    };

    return (
        <div className="container">
            <nav className="top-nav">
                <div className="nav-top-row">
                    <NavLink to="/" className="nav-brand" onClick={handleNavClick} aria-label="Vixo home">
                        vi<span className="nav-brand-x">x</span>o
                    </NavLink>
                    <button
                        type="button"
                        className={`nav-toggle ${mobileMenuOpen ? 'open' : ''}`}
                        onClick={toggleMobileMenu}
                        aria-label="Toggle navigation menu"
                        aria-expanded={mobileMenuOpen}
                    >
                        <Menu size={16} aria-hidden="true" /> Menu
                    </button>

                    {/* Balance sits beside the profile, visible on every screen:
                        in a prepaid product a user who has to go looking for it
                        finds out it is empty by being refused mid-task. */}
                    {user && <WalletBalance />}

                    {user && (
                        <div className="profile" ref={dropdownRef}>
                            {/* A real button, so the menu opens from the keyboard too. */}
                            <button
                                type="button"
                                className="profile-trigger"
                                onClick={toggleDropdown}
                                aria-haspopup="menu"
                                aria-expanded={dropdownOpen}
                            >
                                <img src={user.photoURL} alt="" />
                                <span className="profile-name">{userProfile?.UserName || user.displayName}</span>
                                <ChevronDown size={14} className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`} aria-hidden="true" />
                            </button>
                            {dropdownOpen && (
                                <div className="profile-dropdown">
                                    <button onClick={handleEditProfile} className="dropdown-item">
                                        <UserRound size={16} className="dropdown-icon" aria-hidden="true" />
                                        Edit profile
                                    </button>
                                    <button onClick={handleLogout} className="dropdown-item logout">
                                        <LogOut size={16} className="dropdown-icon" aria-hidden="true" />
                                        Log out
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
                    <NavLink to="Projects" onClick={handleNavClick}>Projects</NavLink>
                    <NavLink to="Schedule" onClick={handleNavClick}>Calendar</NavLink>
                    <NavLink to="SocialMedia" onClick={handleNavClick}>Social accounts</NavLink>
                    <NavLink to="Billing" onClick={handleNavClick}>Billing</NavLink>
                    {isAdmin && <NavLink to="Admin" onClick={handleNavClick}>Admin</NavLink>}
                </div>
            </nav>
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}

export { Landing };